import { AdminProfile } from "@/core/types";
import type { ApiRequest, ApiRequestWith } from "@/api/types";
import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import type { Practice } from "@/portals/admin/(profile)/api/queryFunctions/getPracticeList";
import type { UpdateAdminProfileVariables } from "@/portals/admin/(profile)/api/queryFunctions/updateAdminProfile";

import { httpAuth2 } from "../auth";

type AdminRequestsTyped = {
  fetch_admin_profile: ApiRequest<AdminProfile>;
  fetch_all_practices: ApiRequest<Practice[]>;
  update_profile: ApiRequestWith<void, { body: UpdateAdminProfileVariables }>;
};

export const adminRequestsTyped: AdminRequestsTyped = {
  fetch_admin_profile: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/admin/profile", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<AdminProfile>();
  },

  fetch_all_practices: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/practice/all_practices", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<Practice[]>();
  },

  update_profile: function ({ body, context }) {
    return httpAuth2
      .post("/v1/admin/profile_update", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: body,
      })
      .json<void>();
  },
};
